module.exports = __webpack_public_path__ + "static/img/schengen-2.ebe6c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/schengen-2.jpg
// module id = vso7
// module chunks = 4